import './InstagramPhoto.css'

interface IMobileInstagramPhotoProps {
    top: string
    bottom: string
}

export default function MobileInstagramPhoto(props: IMobileInstagramPhotoProps) {
    return <div className="Instagram_photo_mobile">
        <img src={props.top} className="Instagram_photo_mobile_top"/>
        <img src={props.bottom} className="Instagram_photo_mobile_bottom"/>
    </div>
}